import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Header from './components/Header.jsx';
import Hero from './sections/Hero.jsx';
import HowItWorks from './sections/HowItWorks.jsx';
import Audiences from './sections/Audiences.jsx';
import Differentials from './sections/Differentials.jsx';
import CondominiumFinder from './sections/CondominiumFinder.jsx';
import Plans from './sections/Plans.jsx';
import Faq from './sections/Faq.jsx';
import Footer from './sections/Footer.jsx';

/**
 * Landing page em formato One Page.
 *
 * A ordem das secoes segue o percurso de decisao: o que e -> como funciona ->
 * para quem serve -> por que confiar -> onde atuar (fornecedor) -> quanto custa
 * -> duvidas.
 */
export default function App() {
  return (
    <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      {/* Atalho para quem navega por teclado ou leitor de tela. */}
      <Link
        href="#conteudo"
        sx={{
          position: 'absolute',
          left: -9999,
          top: 8,
          zIndex: 1300,
          px: 2,
          py: 1,
          borderRadius: 1,
          bgcolor: 'secondary.main',
          color: 'secondary.contrastText',
          '&:focus': { left: 8 },
        }}
      >
        Ir para o conteúdo
      </Link>

      <Header />

      <Box component="main" id="conteudo" sx={{ flexGrow: 1 }}>
        <Hero />
        <HowItWorks />
        <Audiences />
        <Differentials />
        <CondominiumFinder />
        <Plans />
        <Faq />
      </Box>

      <Footer />
    </Box>
  );
}
